import { createSelector } from 'reselect';

import getShop from './getShop';

const getNeedBromatologyCheck = createSelector(getShop, shop => {
  const { needBromatologyCheck } = shop;
  return !!needBromatologyCheck;
});

export default getNeedBromatologyCheck;
